import { ButtonVariant } from '@edikk-edikk/country-layout-black';
import { useIsFrontendStyleDefault } from '@edikk-edikk/country-frontend';
import { useMemo } from 'react';

const useMenuButtonVariant = (useAlt: boolean = false): ButtonVariant => {
  const isFrontendStyleDefault = useIsFrontendStyleDefault();

  return useMemo(() => {
    if (useAlt) {
      return ButtonVariant.white65;
    }

    if (isFrontendStyleDefault) {
      return ButtonVariant.black65;
    }

    return ButtonVariant.richMaroon;
  }, [isFrontendStyleDefault, useAlt]);
};

export { useMenuButtonVariant };
